import React from 'react';
import * as S from './Banner.styles';
import marked from 'marked'

type BannerProps = {
  banner_type?: string | number;
  banner_content?: {
    txt_color?: string;
    title_color?: string;
    footer?: string;
    border_color?: string;
    title?: string;
    bg_color?: string;
    footer_color?: string;
    bg_url?: string;
    message?: string;
    messages: {
      logo_url: string;
      message: string;
    }[]
    logo_url?: string;
  };
};

const Banner = (data: BannerProps) => {
  const { banner_type, banner_content } = data;
  if (banner_type == 9) {
    return (
      <S.GoTribe9 backgroundImage={banner_content.bg_url} backgroundColor={banner_content.bg_color} borderColor={banner_content.border_color} color={banner_content.txt_color} >
        <S.imageWrap9>
          <img src={banner_content.logo_url} alt="" style={{ maxHeight: '70px', maxWidth: '123px' }} />
        </S.imageWrap9>
        <S.CardContent9>
          {banner_content.title ? <S.CardTitle9
            dangerouslySetInnerHTML={{
              __html: marked(banner_content.title)
            }}>
          </S.CardTitle9> : null}
          {banner_content.message ? <S.Text9 dangerouslySetInnerHTML={{
            __html: marked(banner_content.message)
          }}></S.Text9> : null}
        </S.CardContent9>
      </S.GoTribe9>
    )
  }

  if (banner_type == 10) {
    return (
      <S.GoTribe backgroundImage={banner_content.bg_url} backgroundColor={banner_content.bg_color} borderColor={banner_content.border_color} color={banner_content.txt_color}>
        <S.imageWrap>
          <img src={banner_content.logo_url} alt="" style={{ maxHeight: '70px', maxWidth: '123px' }} />
        </S.imageWrap>
        <S.CardContent>
          {banner_content.title ? <S.CardTitle style={{ color: banner_content.title_color }} dangerouslySetInnerHTML={{ __html: marked(banner_content.title) }}></S.CardTitle> : null}
          {banner_content.messages && banner_content.messages.length && banner_content.messages.map(function (msg) {

            return (
              <S.ImgTxt>
                <S.IconWrap>
                  {msg.logo_url ?
                    <img src={msg.logo_url} alt="" width='20px' height='20px' /> : null}</S.IconWrap>
                <S.Text dangerouslySetInnerHTML={{
                  __html: marked(msg.message)
                }}></S.Text>
              </S.ImgTxt>

            )
          })}

          {banner_content.footer ? <S.Link style={{ color: banner_content.footer_color }} dangerouslySetInnerHTML={{
            __html: marked(banner_content.footer)
          }}></S.Link> : null}
        </S.CardContent>
      </S.GoTribe>);
  }
  return null;
}

export default Banner;
